export default __webpack_public_path__ + "06c869812d5b940ecd37a721cba61175.png";